import { IstanzaSezioneDati } from '@framework/api-client';
import { yup, YupAnyObjectSchema } from '@framework/validation';
import { useMemo } from 'react';
import { createDeclarationsSchema } from '../../../../../../apps/backoffice-web/src/client/components/schema/task/declaration/validation/createDeclarationsSchema';

interface IParams {
  allDeclarations: IstanzaSezioneDati[] | null | undefined;
}

/**
 * Hook che genera lo schema per la validazione delle dichiarazioni di un procedimento.
 * Necessario per la generazione degli initialValues.
 */
export function useProcedureSchema(params: IParams) {
  const { allDeclarations } = params;

  const schema = useMemo(() => {
    if (!allDeclarations)
      return yup.object().required().noUnknown() as YupAnyObjectSchema;

    const declarationSchema = createDeclarationsSchema(
      // Mettendo le azioni a `[]` le sezioni dati sono considerate tutte "readonly"
      allDeclarations.map(d => ({ azioni: [], sezioneDati: d })),
    );

    return declarationSchema;
  }, [allDeclarations]);

  return schema;
}
